import React from 'react';
import { Link } from 'react-router-dom';

const CtaSection = () => {
  return (
    <section className="bg-white py-16 sm:py-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row rounded-2xl shadow-xl overflow-hidden items-stretch">
          {/* Image Column */}
          <div className="w-full lg:w-5/12">
            <img 
              src="https://images.unsplash.com/photo-1543269865-cbf427effbad?q=80&w=1470&auto=format&fit=crop" 
              alt="Two women collaborating in a modern workspace" 
              className="w-full h-full object-cover"
            />
          </div>
          {/* Text Column */}
          <div className="w-full lg:w-7/12 p-8 md:p-12 lg:p-16 flex flex-col justify-center bg-violet-50">
            <img 
              src="https://www.avanade.com/-/media/images/identity/avanade-logo.ashx" 
              alt="Avanade Logo" 
              className="h-8 mb-6 self-start"
            />
            <h2 className="text-3xl lg:text-4xl font-bold text-[#6E2672] mb-4">
              Are You Ready to Grow and Make a Career Change?
            </h2>
            <p className="text-gray-700 mb-8 text-base leading-relaxed">
              We help our clients advance the world through the power of people and the Microsoft ecosystem. This applies to our people as well as our clients and their customers. We know that the world of technology changes fast. Finding time to learn new skills to keep up with technological advances can seem daunting, whether you're looking to take your first steps in tech or have years of experience under your belt. The Avanade Academies are designed to help you on this journey, whatever your start position is. Through immersive, hands-on training, we help you jump into a technology career, change specialities, or deepen your knowledge in a specific area, including opportunities to earn Microsoft certifications. Get paid to learn and get to know Avanade's culture at the same time.
            </p>
            <Link 
              to="/clients/avanade"
              className="inline-block self-start bg-[#6E2672] text-white font-bold py-3 px-8 rounded-full hover:bg-opacity-90 transition-colors shadow-md"
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection; 